/* Cool Change Co: scroll reveal, word-by-word headings, button fill and magnet hover. */
(function () {
  if (window.ccMotionReady) return;
  window.ccMotionReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var REVEAL = [
    'main .cc__head > p', 'main .cc__head .cc__sub', 'main .cc-split__media', 'main .cc-split__body',
    'main .cc-strip__item', 'main .cc-pcard', 'main .cc-case', 'main .cc-faq details', 'main .cc-faq__promo',
    'main .cc-bd__proof > div', 'main .cc-bd__card', 'main .cc-bd__footer', 'main .cc-vc__item', 'main .cc-card',
    'main .cc-rc__card', 'main .cc-banner__text', 'main .cc-banner .cc-btn', 'main .cc-pc__tabs', 'main .cc-cart-page__side'
  ].join(',');
  var WORDS = 'main .cc h2, main .cc-banner h1, main .cc-banner h2, main .cc-page-title';

  function splitWords(el) {
    if (el.dataset.ccSplit) return;
    el.dataset.ccSplit = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var w = 0;
    nodes.forEach(function (node) {
      var parts = node.nodeValue.split(' ');
      var frag = document.createDocumentFragment();
      parts.forEach(function (part, i) {
        if (part.length) {
          var outer = document.createElement('span');
          outer.className = 'cc-word';
          var inner = document.createElement('span');
          inner.textContent = part;
          inner.style.setProperty('--w', w++);
          outer.appendChild(inner);
          frag.appendChild(outer);
        }
        if (i < parts.length - 1) frag.appendChild(document.createTextNode(' '));
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.classList.add('cc-words');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;

  function setup(root) {
    if (reduce || !io) return;
    var scope = root || document;
    scope.querySelectorAll(WORDS).forEach(function (h) {
      if (h.closest('#cc-buy')) return;
      splitWords(h);
      io.observe(h);
    });
    scope.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.closest('#cc-buy') || el.hasAttribute('data-cc-revealed')) return;
      el.setAttribute('data-cc-reveal', '');
      el.setAttribute('data-cc-revealed', '');
      var idx = 0, s = el.previousElementSibling;
      while (s && idx < 6) { if (s.hasAttribute('data-cc-reveal')) idx++; s = s.previousElementSibling; }
      el.style.setProperty('--cc-d', (idx * 100) + 'ms');
      io.observe(el);
    });
    document.querySelectorAll('main [data-cc-reveal]:not([data-cc-revealed])').forEach(function (el) {
      el.setAttribute('data-cc-revealed', '');
      io.observe(el);
    });
    document.documentElement.classList.add('cc-motion');
  }

  function fillHover() {
    if (!fine) return;
    document.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('.cc-btn');
      if (!b || (e.relatedTarget && b.contains(e.relatedTarget))) return;
      clearTimeout(b._ccT);
      b.classList.remove('is-fill-out');
      void b.offsetWidth;
      b.classList.add('is-fill-in');
    });
    document.addEventListener('mouseout', function (e) {
      var b = e.target.closest && e.target.closest('.cc-btn');
      if (!b || (e.relatedTarget && b.contains(e.relatedTarget))) return;
      b.classList.remove('is-fill-in');
      b.classList.add('is-fill-out');
      b._ccT = setTimeout(function () { b.classList.remove('is-fill-out'); }, 620);
    });
    document.addEventListener('mousemove', function (e) {
      var m = e.target.closest && e.target.closest('[data-cc-magnet]');
      if (!m) return;
      var r = m.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 10;
      var y = ((e.clientY - r.top) / r.height - 0.5) * 10;
      var i = m.querySelector('.cc-i');
      if (i) i.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
    });
    document.addEventListener('mouseout', function (e) {
      var m = e.target.closest && e.target.closest('[data-cc-magnet]');
      if (!m || (e.relatedTarget && m.contains(e.relatedTarget))) return;
      var i = m.querySelector('.cc-i');
      if (i) i.style.transform = '';
    });
  }

  function init() { setup(); fillHover(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
